/**
 * SchedulePushNotification.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import { Title, Body, Submission, formatSubmission } from './PushNotification';
import { NavigationBar } from '../NavigationBar/NavigationBar';
import { stringMatching, useStrings } from '../Theme';

function createTime(_ref, strings) {
  var frequency = _ref.frequency,
      hourAndMinute = _ref.hourAndMinute,
      timeZone = _ref.timeZone,
      dayOfWeek = _ref.dayOfWeek,
      runDate = _ref.runDate;

  switch (frequency) {
    case 'once':
      return formatSubmission(runDate);

    case 'weekly':
      return "".concat(frequency, " ").concat(hourAndMinute, " ").concat(timeZone, " ").concat(stringMatching(strings, dayOfWeek));

    default:
      return 'unknown frequency';
  }
}

function ScheduledPushNotification(_ref2, onClick) {
  var query = _ref2.query,
      schedule = _ref2.schedule,
      payload = _ref2.payload;
  var key = 0;
  var channel = query.channel;
  var title = payload.title,
      body = payload.body;
  var strings = useStrings();
  var time = createTime(schedule, strings);
  return React.createElement('div', {
    className: 'pushNotificationItem scheduledPushNotificationItem',
    key: key++,
    title: stringMatching(strings, 'Edit delayed or periodic push notification'),
    onClick: onClick
  }, [NavigationBar({
    string: channel,
    key: key++,
    className: 'itemNavigationBar'
  }), Submission({
    time: time,
    key: key++
  }), Title({
    title: title,
    key: key++
  }), Body({
    body: body,
    key: key++
  })]);
}

export default ScheduledPushNotification;